import axios from "axios";

interface LoginRequestPayload {
  email: string;
  password: string;
}

const loginKC = {
  submit: async (payload: LoginRequestPayload) => {
    const response = await axios.post("https://support.scodix.com/wp-json/api/v1/auth", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    // Login request succeeded
    return response.data; // Return the response data
  }
};

export default loginKC;
